import { render, staticRenderFns } from "./File.vue?vue&type=template&id=ccb1520e"
import script from "./File.vue?vue&type=script&lang=js"
export * from "./File.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ccb1520e')) {
      api.createRecord('ccb1520e', component.options)
    } else {
      api.reload('ccb1520e', component.options)
    }
    module.hot.accept("./File.vue?vue&type=template&id=ccb1520e", function () {
      api.rerender('ccb1520e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/player/components/File.vue"
export default component.exports